import {
  NormalBrowseFileInputFiled,
  NormalMultipleFixedInputFields,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const InvestorsCornerSecondTabFormFields = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="advertise-with-us-heading"
            fieldName="advertise-with-us-heading"
            placeholderText="Heading"
            inputValue={formData?.["advertise-with-us-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="advertise-with-us-description"
            fieldName="advertise-with-us-description"
            placeholderText="Description"
            inputValue={formData?.["advertise-with-us-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Section Separator */}
          <div className="w-full border border-dashed border-[#00000010] dark:border-[#ffffff10] my-10" />

          {/* Brand Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Brand Section Image"
              fieldId="advertise-with-us-brand-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("advertise-with-us-brand-image", id)
                  : handleImageChange("advertise-with-us-brand-image", "")
              }
              selectedFileId={formData?.["advertise-with-us-brand-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
            />
          )}

          {/* Brand Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Brand Section Heading"
            fieldId="advertise-with-us-brand-heading"
            fieldName="advertise-with-us-brand-heading"
            placeholderText="Brand Section Heading"
            inputValue={formData?.["advertise-with-us-brand-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Brand Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Brand Section Description"
            fieldId="advertise-with-us-brand-description"
            fieldName="advertise-with-us-brand-description"
            placeholderText="Brand Section Description"
            inputValue={formData?.["advertise-with-us-brand-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Brand Button Label */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Brand Section Button Label"
            fieldId="advertise-with-us-brand-button-label"
            fieldName="advertise-with-us-brand-button-label"
            placeholderText="Brand Section Button Label"
            inputValue={
              formData?.["advertise-with-us-brand-button-label"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Section Separator */}
          <div className="w-full border border-dashed border-[#00000010] dark:border-[#ffffff10] my-10" />

          {/* Contact Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Contact Section Heading"
            fieldId="advertise-with-us-contact-heading"
            fieldName="advertise-with-us-contact-heading"
            placeholderText="Contact Section Heading"
            inputValue={formData?.["advertise-with-us-contact-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Contact Options */}
          <NormalMultipleFixedInputFields
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Contact Section Options"
            fieldId="advertise-with-us-contact-options"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            handleImageChange={handleImageChange}
            handleTextInputChange={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
            cards={[
              {
                card_id: "advertise-with-us-contact-options-card-1",
                types: ["IMAGE", "TEXT", "TEXT"],
                is_hidden: [
                  isHideInOtherLanguages,
                  true,
                  isHideInOtherLanguages,
                ],
                ids_name: [
                  "logo_field_id",
                  "text_filed_id_1",
                  "text_filed_id_2",
                ],
                placeholders_name: [
                  "",
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                ],
                // IDs
                logo_field_id: "advertise-with-us-contact-options-card-logo-1",
                text_filed_id_1:
                  "advertise-with-us-contact-options-card-title-1",
                text_filed_id_2:
                  "advertise-with-us-contact-options-card-contact-value-1",
                // Placeholders
                text_filed_placeholder_1: "Title 1",
                text_filed_placeholder_2: "Contact Value 1",
              },
              {
                card_id: "advertise-with-us-contact-options-card-2",
                types: ["IMAGE", "TEXT", "TEXT"],
                is_hidden: [
                  isHideInOtherLanguages,
                  true,
                  isHideInOtherLanguages,
                ],
                ids_name: [
                  "logo_field_id",
                  "text_filed_id_1",
                  "text_filed_id_2",
                ],
                placeholders_name: [
                  "",
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                ],
                // IDs
                logo_field_id: "advertise-with-us-contact-options-card-logo-2",
                text_filed_id_1:
                  "advertise-with-us-contact-options-card-title-2",
                text_filed_id_2:
                  "advertise-with-us-contact-options-card-contact-value-2",
                // Placeholders
                text_filed_placeholder_1: "Title 2",
                text_filed_placeholder_2: "Contact Value 2",
              },
            ]}
          />

          {/* Contact Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Contact Section Image"
              fieldId="advertise-with-us-contact-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("advertise-with-us-contact-image", id)
                  : handleImageChange("advertise-with-us-contact-image", "")
              }
              selectedFileId={
                formData?.["advertise-with-us-contact-image"] || ""
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
              extraContainerClasses="mt-5"
            />
          )}

          {/* Section Separator */}
          <div className="w-full border border-dashed border-[#00000010] dark:border-[#ffffff10] my-10" />

          {/* Form Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Form Section Heading"
            fieldId="advertise-with-us-form-heading"
            fieldName="advertise-with-us-form-heading"
            placeholderText="Form Section Heading"
            inputValue={formData?.["advertise-with-us-form-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Form Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Form Section Description"
            fieldId="advertise-with-us-form-description"
            fieldName="advertise-with-us-form-description"
            placeholderText="Form Section Description"
            inputValue={formData?.["advertise-with-us-form-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Form Button Label */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Form Section Button Label"
            fieldId="advertise-with-us-button-label"
            fieldName="advertise-with-us-button-label"
            placeholderText="Form Section Button Label"
            inputValue={formData?.["advertise-with-us-button-label"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default InvestorsCornerSecondTabFormFields;
